"use client";

import * as React from "react";
import { Globe } from "lucide-react";
import { useLanguage } from "@/lib/i18n/context";

export function LangToggle() {
  const { language, setLanguage, t } = useLanguage();

  const toggleLang = () => {
    setLanguage(language === "pl" ? "en" : "pl");
  };

  return (
    <button
      onClick={toggleLang}
      className="inline-flex items-center justify-center gap-2 rounded-full text-sm font-medium transition-colors hover:bg-zinc-100 hover:text-zinc-900 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-zinc-950 disabled:pointer-events-none disabled:opacity-50 dark:hover:bg-zinc-800 dark:hover:text-zinc-50 dark:focus-visible:ring-zinc-300 h-9 px-3 text-zinc-950 dark:text-zinc-50"
      aria-label={t.nav.toggle}
    >
      <Globe className="h-[1.2rem] w-[1.2rem]" />
      <span className="uppercase">{language}</span>
    </button>
  );
}
